<template>
    <el-dialog title="盘点库存" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
               :close-on-press-escape="false">
        <el-form size="small" :model="form">
            <el-form-item label="产品名称" >
               {{ form.product_name }}
               
            </el-form-item>

            <el-form-item label="条形码" >
               {{ form.product_no }}
               
            </el-form-item>

            <el-form-item label="规格" >
               {{ form.spec_value }}
               
            </el-form-item>

            <el-form-item label="原库存" >
               {{ form.stock_num }}
               
            </el-form-item>

            <el-form-item label="新库存" > 
                <el-input v-model="new_stock_num" style="width: 50%;"></el-input>
               
            </el-form-item>

            <el-form-item label="变动库存" >
                {{new_stock_num-form.stock_num}}
               
            </el-form-item>

            <el-form-item label="最终库存" >
               {{ new_stock_num }}
               
            </el-form-item>
        </el-form>
 

        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible">取 消</el-button>
       
            <el-button type="primary" @click="editWholesale" :loading="loading">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import ProductApi from '@/api/product.js';
    export default {
        data() {
            return {
                /*左边长度*/
                formLabelWidth: '120px',
                /*是否显示*/
                loading: false,
                dialogVisible: false,
                wholesaleList:[],
                new_stock_num:0
            };
        },
        props: ['showCheckStock','form'],
       
        created() {
            this.new_stock_num = this.form.stock_num
            this.dialogVisible = this.$parent.showCheckStock;
        },
        methods: {
            newStockInput(e){
                console.log(e)
            },
            /*关闭弹窗*/
            dialogFormVisible(e) {
                if (e) {
                    this.$emit('closeDialog', {
                        type: 'success',
                        openDialog: false
                    })
                } else {
                    this.$emit('closeDialog', {
                        type: 'error',
                        openDialog: false
                    })
                }
            },
            addWholesale(){
                this.wholesaleList.push({
                    min_num: '',
                    max_num: '',
                    wholesale_price:''
                });
            },
            editWholesale(){
                let self =this;
                let params = {};
                params = this.form;
                let validateFlag = false;
 
                params.new_stock_num = self.new_stock_num;
                ProductApi.checkSku(params, true)
                .then(data => {
                    self.loading = false;
                    self.dialogFormVisible(1);
                })
                .catch(error => {
                self.loading = false;
                });
                    
            },
            removeWholesale(index){
                // var index = this.wholesaleList.domains.indexOf(item)
                if (index !== -1) {
                    this.wholesaleList.splice(index, 1)
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/product/sku/part/checkStock.vue